export default "__VITE_ASSET__592WiFSX__"